/*
kendo.culture.pl-pl.min.js
*/
!function (e) {
    "function" == typeof define && define.amd ? define(["kendo.core.min"], e) : e()
}

    (function () {
        !function (e, y) {
            kendo.cultures["pl-PL"] = {
                name: "pl-PL", numberFormat: {
                    pattern: ["-n"], decimals: 2, ",": " ", ".": ",", groupSize: [3], percent: {
                        pattern: ["-n%", "n%"], decimals: 2, ",": " ", ".": ",", groupSize: [3], symbol: "%"
                    }
                    , currency: {
                        name: "Polish Zloty", abbr: "PLN", pattern: ["-n $", "n $"], decimals: 2, ",": " ", ".": ",", groupSize: [3], symbol: "zł"
                    }
                }
                , calendars: {
                    standard: {
                        days: {
                            names: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"], namesAbbr: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."], namesShort: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."]
                        }
                        , months: {
                            names: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"], namesAbbr: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"]
                        }
                        , AM: ["AM", "am", "AM"], PM: ["PM", "pm", "PM"], patterns: {
                            d: "dd.MM.yyyy", D: "dddd, d MMMM yyyy", F: "dddd, d MMMM yyyy HH:mm:ss", g: "dd.MM.yyyy HH:mm", G: "dd.MM.yyyy HH:mm:ss", m: "d MMMM", M: "d MMMM", s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss", t: "HH:mm", T: "HH:mm:ss", u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'", y: "MMMM yyyy", Y: "MMMM yyyy"
                        }
                        , "/": ".", ":": ":", firstDay: 1
                    }
                }
            }
        }
            (this)
    }

);

/*
 * kendo.culture.pl.min.js
 */
!function (e) {
    "function" == typeof define && define.amd ? define(["kendo.core.min"], e) : e()
}

    (function () {
        !function (e, y) {
            kendo.cultures.pl = {
                name: "pl", numberFormat: {
                    pattern: ["-n"], decimals: 2, ",": " ", ".": ",", groupSize: [3], percent: {
                        pattern: ["-n%", "n%"], decimals: 2, ",": " ", ".": ",", groupSize: [3], symbol: "%"
                    }
                    , currency: {
                        name: "", abbr: "", pattern: ["-n $", "n $"], decimals: 2, ",": " ", ".": ",", groupSize: [3], symbol: "zł"
                    }
                }
                , calendars: {
                    standard: {
                        days: {
                            names: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"], namesAbbr: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."], namesShort: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."]
                        }
                        , months: {
                            names: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"], namesAbbr: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"]
                        }
                        , AM: ["AM", "am", "AM"], PM: ["PM", "pm", "PM"], patterns: {
                            d: "dd.MM.yyyy", D: "dddd, d MMMM yyyy", F: "dddd, d MMMM yyyy HH:mm:ss", g: "dd.MM.yyyy HH:mm", G: "dd.MM.yyyy HH:mm:ss", m: "d MMMM", M: "d MMMM", s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss", t: "HH:mm", T: "HH:mm:ss", u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'", y: "MMMM yyyy", Y: "MMMM yyyy"
                        }
                        , "/": ".", ":": ":", firstDay: 1
                    }
                }
            }
        }
            (this)
    }

);
/*
 * kendo.messages.pl-PL.min.js
 */

!function (e) {
    "function" == typeof define && define.amd ? define(["kendo.core.min"], e) : e()
}

    (function () {
        !function (e, o) {
            kendo.ui.FilterCell && (kendo.ui.FilterCell.prototype.options.operators = e.extend(!0, kendo.ui.FilterCell.prototype.options.operators, {
                date: {
                    eq: "są równe", gte: "są późniejsze lub równe", gt: "są późniejsze niż", lte: "są wcześniejsze lub równe", lt: "są wcześniejsze niż", neq: "są inne niż", isnull: "brak daty", isnotnull: "mają datę"
                }
                , number: {
                    eq: "są równe", gte: "są większe lub równe", gt: "są większe niż", lte: "są mniejsze lub równe", lt: "są mniejsze niż", neq: "są inne niż", isnull: "pusta wartość", isnotnull: "niepusta wartość"
                }
                , string: {
                    endswith: "kończą się na", eq: "są równe", neq: "są inne niż", startswith: "zaczynają się od", contains: "zawierają", doesnotcontain: "nie zawierają"
                }
                , enums: {
                    eq: "są równe", neq: "są inne niż"
                }
            }
            )), kendo.ui.FilterMenu && (kendo.ui.FilterMenu.prototype.options.operators = e.extend(!0, kendo.ui.FilterMenu.prototype.options.operators, {
                date: {
                    eq: "są równe", gte: "są późniejsze lub równe", gt: "są późniejsze niż", lte: "są wcześniejsze lub równe", lt: "są wcześniejsze niż", neq: "są inne niż"
                }
                , number: {
                    eq: "są równe", gte: "są większe lub równe", gt: "są większe niż", lte: "są mniejsze lub równe", lt: "są mniejsze niż", neq: "są inne niż"
                }
                , string: {
                    endswith: "kończą się na", eq: "są równe", neq: "są inne niż", startswith: "zaczynają się od", contains: "zawierają", doesnotcontain: "nie zawierają"
                }
                , enums: {
                    eq: "są równe", neq: "są inne niż"
                }
            }
            )), kendo.ui.ColumnMenu && (kendo.ui.ColumnMenu.prototype.options.messages = e.extend(!0, kendo.ui.ColumnMenu.prototype.options.messages, {
                filter: "Filtr", columns: "Kolumny", sortAscending: "Sortuj Rosnąco", sortDescending: "Sortuj malejąco", settings: "Ustawienia kolumn", done: "Sporządzono", lock: "Zablokować", unlock: "Odblokować"
            }
            )), kendo.ui.RecurrenceEditor && (kendo.ui.RecurrenceEditor.prototype.options.messages = e.extend(!0, kendo.ui.RecurrenceEditor.prototype.options.messages, {
                daily: {
                    interval: "dzień (dni)", repeatEvery: "Powtarzaj każdy:"
                },
                end: {
                    after: "Po", occurrence: "występujący (występujące)", label: "Koniec:", never: "Nigdy", on: "Na", mobileLabel: "Zakończenie"
                },
                frequencies: {
                    daily: "Dziennie", monthly: "Miesięcznie", never: "Nigdy", weekly: "Tygodniowo", yearly: "Rocznie"
                },
                monthly: {
                    day: "Dzień", interval: "miesiąc (miesiące)", repeatEvery: "Powtarzaj każdy:", repeatOn: "Powtarzaj w:"
                },
                offsetPositions: {
                    first: "pierwszy", fourth: "czwarty", last: "ostatni", second: "drugi", third: "trzeci"
                },
                weekly: {
                    repeatEvery: "Powtarzaj każdy:", repeatOn: "Powtarzaj w:", interval: "tydzień (tygodnie)"
                },
                yearly: {
                    of: " ", repeatEvery: "Powtarzaj każdy:", repeatOn: "Powtarzaj w:", interval: "rok (lata)"
                },
                weekdays: {
                    day: "dzień", weekday: "dzień tygodnia", weekend: "dzień weekendu"
                }
            }
            )), kendo.ui.Grid && (kendo.ui.Grid.prototype.options.messages = e.extend(!0, kendo.ui.Grid.prototype.options.messages, {
                commands: {
                    create: "Wstaw", destroy: "Usuń", canceledit: "Anuluj", update: "Aktualizuj", edit: "Edycja", excel: "Export to Excel", pdf: "Export to PDF", select: "Zaznacz", cancel: "Anuluj zmiany", save: "Zapisz zmiany"
                }
                , editable: {
                    confirmation: "Czy na pewno chcesz usunąć ten rekord?", cancelDelete: "Anuluj", confirmDelete: "Usuń"
                },

            }
            )), kendo.ui.Grid && (kendo.ui.Grid.prototype = e.extend(!0, kendo.ui.Grid.prototype, {
                _checkRows: function (t) {
                    t.each(function () {
                        e(this).addClass("k-state-selected").find("input[data-role='checkbox'].k-checkbox").prop("checked", !0).attr("aria-label", "Odznacz wiersz").attr("aria-checked", !0)
                    })
                },
                _uncheckCheckBoxes: function () {
                    var e = this,
                        t = e.table.add(e.lockedTable);
                    t.find("tbody input[data-role='checkbox'].k-checkbox").attr("aria-checked", !1).prop("checked", !1).attr("aria-label", "Odznacz wiersz")
                },
                _deselectCheckRows: function (t) {
                    var r = this;
                    t = r.table.add(r.lockedTable).find(t), r._isLocked() && (t = t.add(t.map(function () {
                        return r._relatedRow(this)
                    }))), t.each(function () {
                        e(this).removeClass("k-state-selected").find("input[data-role='checkbox'].k-checkbox").attr("aria-checked", !1).prop("checked", !1).attr("aria-label", "Zaznacz wiersz")
                    }), r._toggleHeaderCheckState(!1), r._persistSelectedRows(), r.trigger("change")
                },
            }
            )), kendo.ui.Pager && (kendo.ui.Pager.prototype.options = e.extend(!0, kendo.ui.Pager.prototype.options, {
                ARIATemplate: "Nawigacja po stronie, strona #=page# z #=totalPages#"
            }
            )), kendo.ui.Pager && (kendo.ui.Pager.prototype.options.messages = e.extend(!0, kendo.ui.Pager.prototype.options.messages, {
                allPages: "Wszystkie", page: "Strona", display: "Wyświetlanie elementów {0} - {1} z {2}", of: "z {0}", empty: "Brak danych", refresh: "Odśwież", first: "Idź do pierwszej strony", itemsPerPage: "na stronę", last: "Przejdź do ostatniej strony", next: "Przejdź do następnej strony", previous: "Przejdź do poprzedniej strony", morePages: "Więcej stron"
            }
            )), kendo.ui.TreeListPager && (kendo.ui.TreeListPager.prototype.options.messages = e.extend(!0, kendo.ui.TreeListPager.prototype.options.messages, {
                allPages: "Wszystkie", page: "Strona", display: "Wyświetlanie elementów {0} - {1} z {2}", of: "z {0}", empty: "Brak danych", refresh: "Odśwież", first: "Idź do pierwszej strony", itemsPerPage: "na stronę", last: "Przejdź do ostatniej strony", next: "Przejdź do następnej strony", previous: "Przejdź do poprzedniej strony", morePages: "Więcej stron"
            }
            )), kendo.ui.FilterCell && (kendo.ui.FilterCell.prototype.options.messages = e.extend(!0, kendo.ui.FilterCell.prototype.options.messages, {
                filter: "Filtr", clear: "Wyczyść filtr", isFalse: "fałsz", isTrue: "prawda", operator: "Operator"
            }
            )), kendo.ui.FilterMenu && (kendo.ui.FilterMenu.prototype.options.messages = e.extend(!0, kendo.ui.FilterMenu.prototype.options.messages, {
                filter: "Filtr", and: "Oraz", clear: "Wyczyść filtr", info: "Pokaż wiersze o wartościach które", title: "Pokaż wiersze o wartościach które", selectValue: "-Wybierz wartość-", isFalse: "fałsz", isTrue: "prawda", or: "lub", cancel: "Anuluj", operator: "Operator", value: "Wartość", additionalOperator: "Dodatkowy operator", additionalValue: "Dodatkowa wartość", logic: "Logika filtru"
            }
            )), kendo.ui.FilterMultiCheck && (kendo.ui.FilterMultiCheck.prototype.options.messages = e.extend(!0, kendo.ui.FilterMultiCheck.prototype.options.messages, {
                search: "Szukaj"
            }
            )), kendo.ui.Groupable && (kendo.ui.Groupable.prototype.options.messages = e.extend(!0, kendo.ui.Groupable.prototype.options.messages, {
                empty: "Przeciągnij nagłówek kolumny i upuść go tutaj aby pogrupować według tej kolumny"
            }
            )), kendo.ui.Editor && (kendo.ui.Editor.prototype.options.messages = e.extend(!0, kendo.ui.Editor.prototype.options.messages, {
                bold: "Wytłuszczenie",
                createLink: "Wstaw link",
                fontName: "Wybierz czcionkę",
                fontNameInherit: "(czcionka odziedziczona)",
                fontSize: "Wybierz rozmiar czcionki",
                fontSizeInherit: "(rozmiar odziedziczony)",
                formatBlock: "Wybierz rozmiar bloku",
                indent: "Wcięcie",
                insertHtml: "Wstaw HTML",
                insertImage: "Wstaw obraz",
                insertOrderedList: "Wstaw listę numerowaną",
                insertUnorderedList: "Wstaw listę wypunktowaną",
                italic: "Kursywa",
                justifyCenter: "Centruj tekst",
                justifyFull: "Wyrównaj tekst",
                justifyLeft: "Wyrównaj tekst do lewej",
                justifyRight: "Wyrównaj tekst do prawej",
                outdent: "Zmniejsz wcięcie",
                strikethrough: "Przekreślenie",
                styles: "Styl",
                subscript: "Subscript",
                superscript: "Superscript",
                underline: "Podkreślenie",
                unlink: "Usuń link",
                deleteFile: 'Czy na pewno chcesz usunąć "{0}"?',
                directoryNotFound: "Folder o tej nazwie nie został znaleziony.",
                emptyFolder: "Opróżnij folder",
                invalidFileType: 'Wybrany plik "{0}" nie jest prawidłowy. Obsługiwane typy plików to: {1}.',
                orderBy: "Uporządkuj wg:",
                orderByName: "Nazwa",
                orderBySize: "Rozmiar",
                overwriteFile: 'Plik o nazwie "{0}" istnieje już w bieżącym folderze. Czy chcesz go zastąpić?',
                uploadFile: "Załaduj",
                backColor: "Kolor tła",
                foreColor: "Kolor",
                dialogButtonSeparator: "or",
                dialogCancel: "Anuluj",
                dialogInsert: "Wstaw",
                imageAltText: "Opis",
                imageWebAddress: "URL",
                imageWidth: "Szerokość (px)",
                imageHeight: "Wysokość (px)",
                linkWebAddress: "URL",
                linkText: "Tekst",
                linkToolTip: "Podpowiedź",
                linkOpenInNewWindow: "Otwórz w nowym oknie",
                search: "Search",
                createTable: "Tworzenie tabeli",
                createTableHint: "Utwórz tabelę {0} x {1}",
                addColumnLeft: "Dodaj kolumnę z lewej",
                addColumnRight: "Dodaj kolumnę z prawej",
                addRowAbove: "Dodaj wiersz powyżej",
                addRowBelow: "Dodaj wiersz powyżej",
                deleteRow: "Usuń wiersz",
                deleteColumn: "Usuń kolumnę",
                mergeCellsHorizontally: "Złącz komórki w poziomie",
                mergeCellsVertically: "Złącz komórki w pionie",
                splitCellHorizontally: "Podziel komórki w poziomie",
                splitCellVertically: "Podziel komórki w pionie",
                tableWizard: "Szczegóły tabeli",
                tableTab: "Tabela",
                cellTab: "Komórka",
                accessibilityTab: "Dostępność",
                caption: "Nagłówek",
                summary: "Streszczenie",
                width: "Szerokość",
                height: "Wysokość",
                units: "Jednostki",
                cellSpacing: "Odstępy między komórkami",
                cellPadding: "Wewnętrzny odstęp komórek",
                cellMargin: "Margines komórek",
                alignment: "Wyrównanie",
                background: "Tło",
                cssClass: "Klasa CSS",
                id: "ID",
                border: "Brzegi",
                borderStyle: "Styl CSS brzegów",
                collapseBorders: "Sklejaj brzegi",
                wrapText: "Zawijanie wierszy",
                associateCellsWithHeaders: "Powiąż nagłówkami",
                alignLeft: "Wyrównaj w lewo",
                alignCenter: "Centruj",
                alignRight: "Wyrównaj w prawo",
                alignLeftTop: "Wyrównaj w prawo do góry",
                alignCenterTop: "Wyrównaj do środka do góry",
                alignRightTop: "Wyrównaj w prawo do góry",
                alignLeftMiddle: "Wyrównaj w lewo do środka",
                alignCenterMiddle: "Wyrównaj do środka",
                alignRightMiddle: "Wyrównaj w prawo do środka",
                alignLeftBottom: "Wyrównaj w lewo do dołu",
                alignCenterBottom: "Wyrównaj do środka do dołu",
                alignRightBottom: "Wyrównaj w prawo do dołu",
                alignRemove: "Usuń wyrównanie",
                columns: "Kolumny",
                rows: "Wiersze",
                selectAllCells: "Zaznacz wszystkie komórki",
                dropFilesHere: "umieść pliki tutaj, aby je wysłać",
                formatting: "Format",
                viewHtml: "Podgląd HTML",
                dialogUpdate: "Zaktualizuj",
                insertFile: "Wstaw plik",
                editAreaTitle: "Edycja treści. Wciśnij F10 aby przejść do paska narzędzi.",
            }
            ));
            var t = {
                uploadFile: "Wyślij", orderBy: "Sortuj wg", orderByName: "Nazwy", orderBySize: "Rozmiaru", directoryNotFound: "Folder o podanej nazwie nie został odnaleziony.", emptyFolder: "Pusty folder", invalidFileType: 'Wybrany plik "{0}" jest nieprawidłowy. Obsługiwane pliki {1}.', deleteFile: 'Czy napewno chcesz usunąć plik "{0}"?', overwriteFile: 'Plik o nazwie "{0}" już istnieje w bieżącym folderze. Czy zastąpić?', dropFilesHere: "umieść pliki tutaj, aby je wysłać", search: "Szukaj"
            };
            kendo.ui.FileBrowser && (kendo.ui.FileBrowser.prototype.options.messages = e.extend(!0, kendo.ui.FileBrowser.prototype.options.messages, t)), kendo.ui.ImageBrowser && (kendo.ui.ImageBrowser.prototype.options.messages = e.extend(!0, kendo.ui.ImageBrowser.prototype.options.messages, t)), kendo.ui.Upload && (kendo.ui.Upload.prototype.options.localization = e.extend(!0, kendo.ui.Upload.prototype.options.localization, {
                cancel: "Anuluj", dropFilesHere: "przeciągnij tu pliki aby je załadować", remove: "Usuń", retry: "Ponów", select: "Wybierz...", statusFailed: "niepowodzenie", statusUploaded: "załadowane", statusUploading: "trwa ładowanie", uploadSelectedFiles: "Załaduj pliki", headerStatusUploaded: "Zrobione", headerStatusUploading: "Wgrywanie...", invalidMaxFileSize: "Rozmiar pliku jest za duży.", invalidMinFileSize: "Rozmiar pliku jest za mały.", invalidFileExtension: "Niedozwolony rodzaj pliku."
            }
            )), kendo.ui.Scheduler && (kendo.ui.Scheduler.prototype.options.messages = e.extend(!0, kendo.ui.Scheduler.prototype.options.messages, {
                allDay: "cały dzień", cancel: "Anuluj", editable: {
                    confirmation: "Jesteś pewien, że chcesz usunąć do wydarzenie?"
                }
                , date: "Data", destroy: "Usuń", editor: {
                    allDayEvent: "Wydarzenie całodniowe", description: "Opis", editorTitle: "Wydarzenie", end: "Koniec", endTimezone: "Koniec strefy czasowej", repeat: "P", separateTimezones: "Użyj oddzielnie początku i końca stref czasowych", start: "Początek", startTimezone: "Początek strefy czasowej", timezone: " ", timezoneEditorButton: "Strefa czasowa", timezoneEditorTitle: "Strefy czasowe", title: "Tytuł", noTimezone: "Brak strefy czasowej"
                }
                , event: "Wydarzenie", recurrenceMessages: {
                    deleteRecurring: "Chcesz usunąć tylko wskazane wystąpienie zdarzenia czy całą ich serię?", deleteWindowOccurrence: "Usuń obecne zdarzenie", deleteWindowSeries: "Usuń serie", deleteWindowTitle: "Usuń powtarzający się obiekt", editRecurring: "Czesz edytować tylko wskazane wystąpienie zdarzenia czy całą ich serię?", editWindowOccurrence: "Edytuj obecne zdarzenie", editWindowSeries: "Edytu serie", editWindowTitle: "Edytuj powtarzający się obiekt"
                }
                , save: "Zapisz", time: "Czas", today: "Dziś", views: {
                    agenda: "Agenda", day: "Dzień", month: "Miesiąc", week: "Tydzień", workWeek: "Tydzień roboczy"
                }
                , deleteWindowTitle: "Usuń wydarzenie", showFullDay: "Pokaż cały dzień", showWorkDay: "Pokaż godziny robocze", next: "Następny", previous: "Poprzedni", ariaSlotLabel: "Zaznaczone od {0:t} do {1:t}", ariaEventLabel: "{0} na {1:D} w {2:t}",
            }
            )), kendo.ui.Dialog && (kendo.ui.Dialog.prototype.options.messages = e.extend(!0, kendo.ui.Dialog.prototype.options.localization, {
                close: "Zamknąć"
            }
            )), kendo.ui.Alert && (kendo.ui.Alert.prototype.options.messages = e.extend(!0, kendo.ui.Alert.prototype.options.localization, {
                okText: "OK"
            }
            )), kendo.ui.Confirm && (kendo.ui.Confirm.prototype.options.messages = e.extend(!0, kendo.ui.Confirm.prototype.options.localization, {
                okText: "OK", cancel: "Anuluj"
            }
            )), kendo.ui.Prompt && (kendo.ui.Prompt.prototype.options.messages = e.extend(!0, kendo.ui.Prompt.prototype.options.localization, {
                okText: "OK", cancel: "Anuluj"
            }
            )), kendo.ui.ColorPicker && (kendo.ui.ColorPicker.prototype.options = e.extend(!0, kendo.ui.ColorPicker.prototype.options, {
                ARIATemplate: 'Aktualnie wybrany kolor to #=data || ""#'
            }
            )), kendo.ui.DatePicker && (kendo.ui.DatePicker.prototype.options = e.extend(!0, kendo.ui.DatePicker.prototype.options, {
                ARIATemplate: 'Aktualnie wybrana data to #=kendo.toString(data.current, "D")#',
                dateButtonText: "Otwórz podgląd daty",
                timeButtonText: "Otwórz podgląd czasu",
            }
            )), kendo.ui.DropDownList && (kendo.ui.DropDownList.prototype = e.extend(!0, kendo.ui.DropDownList.prototype, {
                _span: function () {
                    var t, i = this,
                        n = i.wrapper,
                        s = "span.k-input";
                    t = n.find(s), t[0] || (n.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="Wybierz"><span class="k-icon k-i-arrow-60-down"></span></span></span>').append(i.element), t = n.find(s)), i.span = t, i._inputWrapper = e(n[0].firstChild), i._arrow = n.find(".k-select"), i._arrowIcon = i._arrow.find(".k-icon")
                }
            }
            )), kendo.ui.NumericTextBox && (kendo.ui.NumericTextBox.prototype.options = e.extend(!0, kendo.ui.NumericTextBox.prototype.options, {
                upArrowText: "Zwiększ wartość", downArrowText: "Zmniejsz wartość"
            }
            )), kendo.ui.DatePicker && (kendo.ui.DatePicker.prototype = e.extend(!0, kendo.ui.DatePicker.prototype, {
                _icon: function () {
                    var t, a = this,
                        n = a.element;
                    t = n.next("span.k-select"), t[0] || (t = e('<span unselectable="on" class="k-select" aria-label="wybierz"><span class="k-icon k-i-calendar"></span></span>').insertAfter(n)), a._dateIcon = t.attr({
                        role: "button",
                        "aria-controls": a.dateView._dateViewID
                    })
                }
            }
            )), kendo.ui.SchedulerView && (kendo.ui.SchedulerView.prototype = e.extend(!0, kendo.ui.SchedulerView.prototype, {
                _verticalSlots: function (t, e, n, o) {
                    if (e[0] !== undefined) {
                        var i, s, r = this.groups[t.groupIndex],
                            l = {
                                startSlot: e[0].start,
                                endSlot: e[e.length - 1].end
                            };
                        return n || (i = this._normalizeVerticalSelection(t, e, o), i && (l.startSlot = l.endSlot = i)), s = o ? "upSlot" : "downSlot", l = this._getNextVerticalRange(r, s, l, n), n || !this._isVerticallyGrouped() || l.startSlot && l.endSlot || (l.startSlot = l.endSlot = this._isGroupedByDate() ? this._changeDate(t, i, o) : this._changeGroup(t, o)), l
                    }
                    return false;
                }
            }
            )), kendo.ui.MultiDayView && (kendo.ui.MultiDayView.prototype = e.extend(!0, kendo.ui.MultiDayView.prototype, {
                _updateDirection: function (e, t, a, s, i) {
                    if (t[0] !== undefined) {
                        var n = e.isAllDay,
                            o = t[0].start,
                            r = t[t.length - 1].end;
                        a && (i ? n || o.index !== r.index || o.collectionIndex !== r.collectionIndex || (e.backward = s) : (n && o.index === r.index || !n && o.collectionIndex === r.collectionIndex) && (e.backward = s))
                    }
                }
            }))
            //    , kendo.ui.Switch && (kendo.ui.Switch.prototype = e.extend(!0, kendo.ui.Switch.prototype, {
            //    _aria: function () {
            //        var t, c = this,
            //            a = c.element,
            //            i = c.wrapper,
            //            s = a.attr("id"),
            //            d = e('label[for="' + s + '"]'),
            //            l = a.attr("aria-label"),
            //            r = a.attr("aria-labelledby"),
            //            db = a.attr("aria-describedby"); <- dodane
            //        l ? i.attr("aria-label", l) : r ? i.attr("aria-labelledby", r) : d.length && (t = d.attr("id"), t || (t = (s || n.guid()) + b, d.attr("id", t)), i.attr("aria-labelledby", t)) && db ? i.attr("aria-describedby", db) : d.length <- dodane
            //    }
            //}
        }
            (window.kendo.jQuery)
    }
);



